export enum SiteList {
  UNKNOWN = '',
  ATK = 'ATK',
  CCO = 'CCO',
  CIO = 'CIO',
  SCI = 'SCI',
  COOKING_SCHOOL = 'COOKING_SCHOOL',
  atk = 'atk',
  cco = 'cco',
  cio = 'cio',
  sci = 'sci',
}
